module.exports = __webpack_public_path__ + "img/face-tongue-money.26a80ec0.svg";